import { combineReducers } from '@reduxjs/toolkit';
import { sharedReducer } from 'common/modules/ReactShared';
import { ReducersMapObject } from 'redux';
import classQuizReducer from 'students/views/pages/ClassQuiz/store/slice';
import articlesReducer from './articles/slice';
import authReducer from './auth';
import expressLessonReducer from './expressLesson/slice';
import modalReducer from './modal';
import routerHistoryReducer from './routerHistory';
import wordsReducer from './words/slice';

interface IState {
  shared: ReturnType<typeof sharedReducer>;
  auth: ReturnType<typeof authReducer>;
  modal: ReturnType<typeof modalReducer>;
  routerHistory: ReturnType<typeof routerHistoryReducer>;
  articles: ReturnType<typeof articlesReducer>;
  words: ReturnType<typeof wordsReducer>;
  expressLesson: ReturnType<typeof expressLessonReducer>;
  classQuiz: ReturnType<typeof classQuizReducer>;
}

const reducerMap: ReducersMapObject<IState> = {
  shared: sharedReducer,
  auth: authReducer,
  modal: modalReducer,
  routerHistory: routerHistoryReducer,
  articles: articlesReducer,
  words: wordsReducer,
  expressLesson: expressLessonReducer,
  classQuiz: classQuizReducer
};

const rootReducer = combineReducers(reducerMap);

export default rootReducer;
